module.exports = __webpack_public_path__ + "img/plan.27f3e9c2.svg";